export default {
  "organization": {
    "title": "How We Are Organized",
    "description": "The Volcanic Region Coffees brand is regulated, controlled and protected by:",
    "association_name": "Association of Coffee Producers of the Volcanic Region",
    "about": "We are a non-profit organization with a representative character, formed by members and partnerships focused on regional coffee development.",
    "purpose_title": "Our Purpose",
    "purpose_description": "Our goal is to create perception and belonging, going beyond quality, creating real opportunities and transforming the way we produce, market, value and consume our coffee inside and outside the region.",
    "image_src": "/images/organization/en-q-org.png"
  }
}
